export const PATIENT_SETTINGS_HOME_ROUTE = "/settings/patient";
export const PATIENT_SETTINGS_PROFILE_ROUTE = "/settings/patient/p";

export const DOCTOR_SETTINGS_HOME_ROUTE = "/settings/doctor";
export const DOCTOR_SETTINGS_PROFILE_ROUTE = "/settings/doctor/p";
export const DOCTOR_SETTINGS_CONSULTANCIES_ROUTE =
  "/settings/doctor/p/consultancies/edit";
